export const activeAssertionErrorMessage =
  'Active and previously active configs cannot be edited';

export const noWorkflowFoundErrorMessage = 'No Intent Workflow found';

export const NO_RECORDING_FOUND_ERRORS_MESSAGES = [
  'Recording ID not found',
  'Download link not found',
  'Recording not found',
];
